module.exports = new __parcel__URL__("error.8fed59f7.svg").toString();